@if (formModel) {
  <div class="row mb-3">
    <div class="{{look}}">
      <loren-card [title]="formModel.formName" [subTitle]="" [look]="cardLook">
        <loren-entity-form #form
          [formModel]="formModel"
          [validateNonDirtyOnSubmit]="validateNonDirtyFormOnSubmit"
          (submitForm)="onSubmit($event)"
          (formFieldInteraction)="handleFormFieldInteraction($event)">
        </loren-entity-form>
        <ng-container actionsTemplate>
          <button mat-button color="basic" (click)="handleCancelClick()">
            {{'operations.cancel' | transloco}}
          </button>
          <button *lorenShowForPrivileges="editActionsRoles" mat-stroked-button color="primary" (click)="form.onSubmit()" [disabled]="formModel.disableSaveBtn">
            {{'operations.save' | transloco}}
          </button>
          <ng-container  *lorenShowForPrivileges="editActionsRoles">
            @if (formModel.deleteActionPath) {
              <button mat-button color="warn" class="float-right" (click)="handleDeleteClick()">
                <mat-icon>delete</mat-icon>
                @if (!isHandset) {
                  {{'operations.delete' | transloco}}
                }
              </button>
            }
          </ng-container>
        </ng-container>
      </loren-card>
    </div>
  </div>
}
